// import React from 'react';
// import "./App.css";
// import Header from './components/header/Header';
// import Home from './components/home/Home';
// import About from './components/about/About';
// import Skills from './components/skills/Skills';
// import Services from './components/services/Services';
// // import Qualification from './components/qualification/Qualification';
// import Work from './components/Portfolio/Work';
// import Testimonials from './components/testimonials/Testimonials';
// import Contact from './components/contact/Contact';
// import Footer from './components/footer/Footer';
// import ScrollUp from './components/scrollup/ScrollUp';
// import MissionVision from './components/qualification/MissionVision';

// const App = () => {
//   return (
//     <>
//     <Header />

//     <main className='main'>
//       <Home />
//       <About />
//       <Skills />
//       <Services />
//       {/* <Qualification /> */}
//       <MissionVision />
//       <Work />
//       <Testimonials />
//       <Contact />
//     </main>

//     <Footer />
//     <ScrollUp />
//     </>
//   )
// }

// export default App

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import "./App.css";
import Header from './components/header/Header';
import Home from './components/home/Home';
import About from './components/about/About';
import Skills from './components/skills/Skills';
import Services from './components/services/Services';
// import Qualification from './components/qualification/Qualification';
import Work from './components/Portfolio/Work';
import Testimonials from './components/testimonials/Testimonials';
import Contact from './components/contact/Contact';
import Footer from './components/footer/Footer';
import ScrollUp from './components/scrollup/ScrollUp';
import MissionVision from './components/qualification/MissionVision';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy'; // Import PrivacyPolicy component

const App = () => {
  return (
    <Router>
      <Header />

      <main className='main'>
        <Routes>
          {/* Home Page Routes */}
          <Route path="/" element={
            <>
              <Home />
              <About />
              <Skills />
              <Services />
              {/* <Qualification /> */}
              <MissionVision />
              <Work />
              <Testimonials />
              <Contact />
            </>
          } />

          {/* Privacy Policy Route */}
          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
        </Routes>
      </main>

      <Footer />
      <ScrollUp />
    </Router>
  );
}

export default App;
